import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner'; // cant use '@components/common';

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuthContext();

    if (loading) {
        return <LoadingSpinner message="Checking authentication..." />;
    }

    if (!user) {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
};